module.exports = __webpack_public_path__ + "static/media/Inspiron8.b4a62ff0.png";